export default {
    path: '/spectaculars',
    component: () => import('@/views/layout.vue'),
    redirect: '',
    name: 'spectaculars',
    sort: 3,
    icon: 'el-icon-s-marketing',
    meta: { title: '看板', authCode: ['KANBAN001'] },
    children: [
        {
            path: '/facilitySpectaculars',
            name: 'facilitySpectaculars',
            // hidden: true,
            component: () => import('@/views/permission/spectaculars/facilitySpectaculars.vue'),
            meta: {
                title: '设备看板',
                authCode: ['SHEBEI001']
            }
        },
        {
            path: '/manuSpectaculars',
            name: 'manuSpectaculars',
            hidden: true,
            component: () => import('@/views/permission/spectaculars/manuSpectaculars.vue'),
            meta: {
                title: '设备看板',
                authCode: ['SHEBEI001']
            }
        },
        {
            path: '/acoustoSpectaculars',
            name: 'acoustoSpectaculars',
            component: () => import('@/views/permission/spectaculars/acoustoSpectaculars.vue'),
            meta: {
                title: '报警看板',
                authCode: ['BAOJING001']
            }
        },
        {
            path: '/userSpectaculars',
            name: 'userSpectaculars',
            component: () => import('@/views/permission/spectaculars/userSpectaculars.vue'),
            meta: {
                title: '人员看板',
                authCode: ['RENYUAN001']
            }
        },
        {
            path: '/examineSpectaculars',
            name: 'examineSpectaculars',
            component: () => import('@/views/permission/spectaculars/examineSpectaculars.vue'),
            meta: {
                title: '点检看板',
                authCode: ['DIANJIAN001']
            }
        },
        {
            path: '/planningSpectaculars',
            name: 'planningSpectaculars',
            component: () => import('@/views/permission/spectaculars/planningSpectaculars.vue'),
            meta: {
                title: '保养看板',
                authCode: ['BAOYANG001']
            }
        }
    ],
}

